/**
 * Created by Florin David on 07/12/2016.
 */
import { State } from 'reducers'
import debounce from 'lodash.debounce'
import traverse from 'traverse'

import version from 'lib/version'
import { getState } from 'lib/store'

import initState from 'lib/init-state'
import localStorage from 'lib/local-storage'
import { InitialState } from 'initialState'

/**
 * Get redux state from local storage
 *
 * @return {Object} state
 */
export const get = (): InitialState => {
  const localState = (localStorage.get('state') || {}) as State

  // compare the local state version and application version
  if (
    localState.version &&
    (localState.version.split('.')[0] !== version.split('.')[0] || // major release
      localState.version.split('.')[1] !== version.split('.')[1]) // minor release
  ) {
    const state = initState(localState)
    // clear this after `initState()` call
    localStorage.clear('state')
    return state
  }

  /* eslint-disable no-invalid-this */

  // update all state leafs that starts with fetching with false
  const cleanState = traverse(localState).forEach(function (): void {
    if (
      this.key &&
      (this.key.indexOf('fetching') === 0 ||
        this.key.indexOf('uploading') === 0 ||
        this.key.indexOf('running') === 0 ||
        this.key.indexOf('saving') === 0 ||
        this.key.indexOf('deleting') === 0 ||
        this.key.indexOf('updating') === 0)
    ) {
      if (typeof this.node === 'boolean') {
        this.update(false)
      } else if (Array.isArray(this.node)) {
        this.update([])
      }
    }
  })

  /* eslint-enable no-invalid-this */

  return {
    ...cleanState,
    ...initState(),
  }
}

/**
 * Save redux store to local storage (once a second)
 */
export const save = debounce(
  (): void => {
    localStorage.set('state', getState())
  },
  1000,
  { trailing: true },
)

/**
 * Remove the state from local storage
 */
export const clearCache = (): void => {
  localStorage.clear('state')
}

export default {
  get,
  save,
  clearCache,
}
